import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import useAgreementColumns from "../../../../agreements/hooks/useAgreementColumns";
import useAgreementsQuery from "../../../../agreements/hooks/useAgreementsQuery";
import CollectionDataTable from "../../../../ui/components/CollectionDataTable/CollectionDataTable";

export default function PublisherAgreements({ publisher, organization }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const query = useAgreementsQuery({ firstPartyId: organization.id, secondPartyId: publisher.id });
	const columns = useAgreementColumns();

	return (
		<>
			<Header as="h3">{t("agreements", "Agreements")}</Header>

			<Card fluid>
				<Card.Content>
					<CollectionDataTable
						query={query}
						columns={columns}
						hiddenColumns={["secondParty.name"]}
						onClick={({ id }) => navigate(`../../finance/agreements/${id}`)}
						sortBy={{
							id: "created",
							desc: true,
						}}
					/>
				</Card.Content>
			</Card>
		</>
	);
}
